// extracted by mini-css-extract-plugin
module.exports = {"headline-flash":"headline-flash__23BMI"};